export const getProductionScheduleEnabled = (state) => {
  return state?.companySettings?.productionScheduleEnabled ?? false;
};
